import { useTranslation, Trans } from 'next-i18next';

interface IBeddingSectionStack {
  stackID: string;
}

const BeddingSectionStack = ({ stackID }: IBeddingSectionStack) => {
  const { t: tBedding } = useTranslation('', { keyPrefix: '$pages.$home.$beddingSection' });
  return (
    <div className={`stack-item ${stackID}`}>
      <h3>
        <Trans i18nKey={`${stackID}Title`} t={tBedding} components={{ span: <span /> }} />
      </h3>
      <p className="sub-copy">{tBedding(`${stackID}Description`)}</p>
    </div>
  );
};

export default BeddingSectionStack;
